import type React from "react";
import clsx from "clsx";
import { useCombobox } from "downshift";

import { type FormSelectChoice } from "@/lib/types/types";

import { SelectListComponent } from "./SelectList/SelectListComponent";
import { SelectButtonComponent } from "./SelectButton/SelectButtonComponent";

interface SelectProps {
  className?: string;
  isErrored?: boolean;
  onChange: any;
  options: FormSelectChoice[];
  overrideInputClassName?: string;
  placeholder?: string;
  value?: FormSelectChoice;
  DisplayValueDecorator?: React.ReactNode;
  id?: string;
}

const itemToString = (item: FormSelectChoice) => (item ? item.label : "");

const Select = ({
  className,
  isErrored = false,
  onChange,
  options,
  overrideInputClassName,
  placeholder = "",
  value,
  DisplayValueDecorator,
  id,
}: SelectProps) => {
  const {
    isOpen,
    getInputProps,
    getMenuProps,
    getToggleButtonProps,
    getItemProps,
    highlightedIndex,
  } = useCombobox({
    id,
    onSelectedItemChange: ({ selectedItem: newSelectedItem }) => onChange(newSelectedItem),
    items: options,
    itemToString,
    initialSelectedItem: value && value.value && value.label ? value : undefined,
  });
  const displayValue = value?.label || "";

  return (
    <div className={clsx("sid-select-list", className)}>
      <input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...getInputProps()}
        className={`
                    sid-l-full-width
                    ${overrideInputClassName || "sid-select-input"}
                    ${isErrored ? "sid-select-input--error" : ""}
                  `}
        placeholder={placeholder}
        readOnly
      />

      {displayValue && (
        <span className="sid-select-display">
          {DisplayValueDecorator && DisplayValueDecorator}
          <span aria-hidden>{displayValue}</span>
          <SelectButtonComponent getToggleButtonProps={getToggleButtonProps} isOpen={isOpen} />
        </span>
      )}

      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <div {...getMenuProps()}>
        {isOpen && (
          <SelectListComponent
            highlightedIndex={highlightedIndex}
            itemToString={itemToString}
            options={options}
            getItemProps={getItemProps}
          />
        )}
      </div>
    </div>
  );
};

export const SelectComponent = Select;
